import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { UploadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Button,
  Divider,
  InputNumber,
  Checkbox,
  Row,
  Col,
  Typography,
  Card,
} from "antd";
import { BiArrowBack } from "react-icons/bi";
import { createSchool } from "../features/schools/schoolSlice";
import { getStates } from "../features/statecity/statecitySlice";
import {
  getBrands,
  getJobtrades,
  getSectors,
  getPrograms,
} from "../features/brand/brandSlice";

const { Title } = Typography;
const { Option } = Select;

const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 8 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 16 } },
};
const tailFormItemLayout = {
  wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 16, offset: 8 } },
};
const dataSchoolCategory = [
  { key: "1", value: "Samagra" },
  { key: "2", value: "STAR" },
  { key: "3", value: "PM SHRI" },
];

const Addschool = () => {
  const statelistState = useSelector((state) => state.statecity.statelist);
  const classlistState = useSelector((state) => state.brand.brands);
  const jobtradelistState = useSelector((state) => state.brand.jobtrades);
  const programlistState = useSelector((state) => state.brand.programs);
  const sectorlistState = useSelector((state) => state.brand.sectors);
  const schoolState = useSelector((state) => state.school);
  const {
    isSuccess,
    isError,
    isLoading,
    // message,
    errorMessage,
    createdschool,
  } = schoolState;

  const [selectedState, setSelectedState] = useState("");
  const [districtOptions, setDistrictOptions] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [hiddenInputValue, setHiddenInputValue] = useState("");
  const [loading, setLoading] = useState(false); // Loading state

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getStates());
    dispatch(getJobtrades());
    dispatch(getBrands());
    dispatch(getPrograms());
    dispatch(getSectors());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState) fetchDistricts(selectedState);
  }, [selectedState]);

  const handleButtonClickSchool = () => {
    navigate("/admin/add-bulkschool");
  };

  const handleStateChange = (value) => {
    const [state_id, state_code, state_name] = value.split("|");

    const modifiedValues = {
      ...value,
      state_id,
      state_name,
    };

    setSelectedState(state_code);
    setHiddenInputValue(state_code);
  };

  const fetchDistricts = async (stateCode) => {
    const vtfilterData = statelistState.filter(
      (distric) => distric.state === stateCode
    );
    setDistrictOptions(vtfilterData);
    setLoadingDistricts(true);
  };

  const onFinish = (values) => {
    setLoading(true); // Set loading to true when submission starts
    const [state_id, state_code, state] = values.state.split("|");

    const modifiedValues = {
      ...values,
      state_id,
      state_code,
      state,
    };

    dispatch(createSchool(modifiedValues));

    setTimeout(() => {
      //dispatch(resetState());
      setLoading(false); // Set loading to false after submission
    }, 300);
  };

  useEffect(() => {
    if (isSuccess && createdschool) {
      toast.dismiss();
      toast.success("School Added Successfully!", { autoClose: 5000 });
      navigate("/admin/schools");
    }

    if (isError) {
      toast.dismiss();
      toast.error(errorMessage, { autoClose: 5000 });
    }
  }, [isSuccess, isError, errorMessage, isLoading]);

  return (
    <div
      style={{
        padding: "2rem",
        backgroundColor: "#f0f2f5",
        minHeight: "100vh",
      }}
    >
      <Button
        type="link"
        onClick={() => navigate(-1)}
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1rem",
          color: "#4a90e2",
        }}
      >
        <BiArrowBack /> Go Back
      </Button>

      <Card
        style={{ maxWidth: "800px", margin: "auto", borderRadius: "8px" }}
        bodyStyle={{ padding: "2rem" }}
      >
        <Title level={4} style={{ textAlign: "center", color: "#4a90e2" }}>
          Create a School
        </Title>
        <Divider />
        <Form
          {...formItemLayout}
          form={form}
          name="register"
          onFinish={onFinish}
          initialValues={{ prefix: "+91" }}
          scrollToFirstError
        >
          <Title level={5} style={{ color: "#4a90e2" }}>
            Basic Information
          </Title>
          <Form.Item
            name="UDISE_Code"
            label="UDISE Code"
            tooltip="Enter UDISE Code"
            rules={[
              {
                required: true,
                message: "Please enter UDISE Code!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="School_category"
            label="School Category"
            rules={[
              { required: true, message: "Please select a School Category!" },
            ]}
          >
            <Select placeholder="Select School Category">
              {dataSchoolCategory.map((sec) => (
                <Option key={sec.key} value={sec.value}>
                  {sec.value}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="School_program"
            label="School Program"
            rules={[
              { required: false, message: "Please select a School Program!" },
            ]}
          >
            <Select placeholder="Select School Category">
              {programlistState.map((sec) => (
                <Option key={sec._id} value={sec.title}>
                  {sec.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="school_name"
            label="School Name"
            tooltip="Enter School Name"
            rules={[
              {
                required: true,
                message: "Please enter school name!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="principal_name"
            label="Principal's Name"
            rules={[
              {
                required: true,
                message: "Please enter principal's name!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="phone_no"
            label="Phone Number"
            rules={[{ required: true, message: "Please enter phone number!" }]}
          >
            <Input
              addonBefore={
                <Select defaultValue="+91" style={{ width: 70 }}>
                  <Option value="91">+91</Option>
                </Select>
              }
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item
            name="state"
            label="State"
            rules={[{ required: true, message: "Please select state!" }]}
          >
            <Select
              placeholder="Select State"
              onChange={handleStateChange}
              value={selectedState}
            >
              {statelistState.map((state) => (
                <Option
                  key={state._id}
                  value={`${state._id}|${state.code}|${state.state_name}`}
                >
                  {state.state_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <input type="hidden" name="code" value={hiddenInputValue} />
          <Form.Item
            name="district"
            label="District"
            rules={[{ required: true, message: "Please select district!" }]}
          >
            <Select placeholder="Select District" disabled={!selectedState}>
              {districtOptions.map((district) =>
                district.district_name.map((districtName, idx) => (
                  <Option key={idx} value={districtName}>
                    {districtName}
                  </Option>
                ))
              )}
            </Select>
          </Form.Item>
          <Form.Item
            name="no_of_student"
            label="Number of Students"
            rules={[
              { required: true, message: "Please enter number of students!" },
            ]}
          >
            <InputNumber min={1} style={{ width: "100%" }} />
          </Form.Item>
          <Divider />
          <Title level={5} style={{ color: "#4a90e2" }}>
            Location Details
          </Title>
          <Form.Item
            name="address"
            label="Enter Address"
            rules={[
              {
                required: true,
                message: "Please enter address!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="village"
            label="Village/Town"
            rules={[
              {
                required: true,
                message: "Please enter village!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="pincode"
            label="Pincode"
            rules={[
              {
                required: true,
                message: "Please enter pincode!",
                whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Divider />
          <Title level={5} style={{ color: "#4a90e2" }}>
            Trades
          </Title>
          <Form.Item
            name="trades"
            label="Select Trade"
            rules={[
              { required: true, message: "Please select at least one Trade!" },
            ]}
          >
            <Checkbox.Group style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                {sectorlistState.map((trade, index) => (
                  <Col span={8} key={index}>
                    <Checkbox value={trade.title}>{trade.title}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Divider />
          <Title level={5} style={{ color: "#4a90e2" }}>
            Job Roles
          </Title>
          <Form.Item
            name="jobroles"
            label="Select Job Roles"
            rules={[
              {
                required: true,
                message: "Please select at least one Job Role!",
              },
            ]}
          >
            <Checkbox.Group style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                {jobtradelistState.map((trade, index) => (
                  <Col span={8} key={index}>
                    <Checkbox value={trade.title}>{trade.title}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Divider />
          <Title level={5} style={{ color: "#4a90e2" }}>
            Class
          </Title>
          <Form.Item
            name="classes"
            label="Select Class"
            rules={[
              { required: true, message: "Please select at least one class!" },
            ]}
          >
            <Checkbox.Group style={{ width: "100%" }}>
              <Row gutter={[16, 16]}>
                {classlistState.map((cls, index) => (
                  <Col span={8} key={index}>
                    <Checkbox value={cls.title}>{cls.title}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          <Divider />
          <Form.Item {...tailFormItemLayout}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "20%" }}
              loading={loading}
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Card>
      <Divider />
      <Button
        type="primary"
        className="exportcsv"
        style={{ display: "flex", alignItems: "right" }}
        onClick={handleButtonClickSchool}
      >
        <UploadOutlined />
        Bulk Upload Schools
      </Button>
    </div>
  );
};

export default Addschool;
